import Trigger from 'eflex/models/trigger';
import { attr } from '@ember-data/model';

export default class PlcHardwareTrigger extends Trigger {
  @attr('string') action;
}
